import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Notebook icon
 *
 * @file Notebook.jsx
 */
const Notebook = props => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M18,1 C18.5522847,1 19,1.44771525 19,2 L20.5,2 C21.8807119,2 23,3.11928813
      23,4.5 L23,15.1715729 C23,15.7020059 22.7892863,16.2107137 22.4142136,16.5857864
      L16.5857864,22.4142136 C16.2107137,22.7892863 15.7020059,23 15.1715729,23 L3.5,23
      C2.11928813,23 1,21.8807119 1,20.5 L1,4.5 C1,3.11928813 2.11928813,2 3.5,2
      L5,2 C5,1.44771525 5.44771525,1 6,1 C6.55228475,1 7,1.44771525 7,2 L9,2 C9,1.44771525
      9.44771525,1 10,1 C10.5522847,1 11,1.44771525 11,2 L13,2 C13,1.44771525 13.4477153,1
      14,1 C14.5522847,1 15,1.44771525 15,2 L17,2 C17,1.44771525 17.4477153,1 18,1
      Z M5,4 L3.5,4 C3.22385763,4 3,4.22385763 3,4.5 L3,4.5 L3,20.5 C3,20.7761424
      3.22385763,21 3.5,21 L3.5,21 L15,21 L15,17.5 C15,16.1192881 16.1192881,15
      17.5,15 L17.5,15 L21,15 L21,4.5 C21,4.22385763 20.7761424,4 20.5,4 L20.5,4
      L19,4 L19,5 C19,5.55228475 18.5522847,6 18,6 C17.4477153,6 17,5.55228475
      17,5 L17,5 L17,4 L15,4 L15,5 C15,5.55228475 14.5522847,6 14,6 C13.4477153,6
      13,5.55228475 13,5 L13,5 L13,4 L11,4 L11,5 C11,5.55228475 10.5522847,6 10,6
      C9.44771525,6 9,5.55228475 9,5 L9,5 L9,4 L7,4 L7,5 C7,5.55228475 6.55228475,6
      6,6 C5.44771525,6 5,5.55228475 5,5 L5,5 L5,4 Z"
    />
  </SvgIcon>
);

export default Notebook;
